import React from 'react';
import styled from 'styled-components';
import LinkButton from './LinkButton';
import __ from '../utils/translator';

export default ({ onClick, ...props }) => (
  <Container {...props}>
    <p style={{ marginTop: 0, marginBottom: 0, }}>
      {__('When you are done studying, mark this theme as completed by tapping the button below.')}
    </p>

    <LinkButton
      style={{ marginTop: '2rem', }}
      onClick={onClick}
      color="secondary"
      size="large"
      to="#">
      {__('Mark as completed')}
    </LinkButton>
  </Container>
);

const Container = styled.div`
  padding: 4rem 2.5rem;
  text-align: center;
  background-color: #222;
  color: #fff;
`;
